const LETTER_REGEX = /\p{L}/u;

export function getFirstLetter(word = "") {
  const match = String(word).match(LETTER_REGEX);
  return match ? match[0] : "";
}

export function getLastLetter(word = "") {
  const letters = [...String(word)].filter((char) => LETTER_REGEX.test(char));
  return letters.length > 0 ? letters[letters.length - 1] : "";
}

function getLetterIndices(word = "") {
  const indices = [];
  [...String(word)].forEach((char, index) => {
    if (LETTER_REGEX.test(char)) indices.push(index);
  });
  return indices;
}

function pickRandomItems(items, count) {
  const pool = [...items];
  const picked = [];
  while (picked.length < count && pool.length > 0) {
    const index = Math.floor(Math.random() * pool.length);
    picked.push(pool.splice(index, 1)[0]);
  }
  return picked;
}

export function buildElixirPattern(word = "") {
  const chars = [...String(word)];
  const letterIndices = getLetterIndices(word);
  const revealCount = Math.min(2, letterIndices.length);
  const revealedIndices = new Set(pickRandomItems(letterIndices, revealCount));

  return chars
    .map((char, index) => {
      if (!LETTER_REGEX.test(char)) return char;
      return revealedIndices.has(index) ? char : "-";
    })
    .join("");
}

export function buildRemedeHint(word = "") {
  const letter = getFirstLetter(word);
  if (!letter) return null;
  return {
    type: "remede",
    firstLetter: letter,
  };
}

export function buildPhiltreHint(word = "") {
  const firstLetter = getFirstLetter(word);
  const lastLetter = getLastLetter(word);
  if (!firstLetter || !lastLetter) return null;
  return {
    type: "philtre",
    firstLetter,
    lastLetter,
  };
}

export function buildElixirHint(word = "") {
  const pattern = buildElixirPattern(word);
  if (!pattern) return null;
  return {
    type: "elixir",
    pattern,
  };
}

export function buildPotionHint(potionId, word = "") {
  switch (potionId) {
    case "remede-ignorance":
      return buildRemedeHint(word);
    case "philtre-mnesique":
      return buildPhiltreHint(word);
    case "elixir-clarte":
      return buildElixirHint(word);
    default:
      return null;
  }
}

const WORD_POTION_HINT_TYPES = new Set(["remede", "philtre", "elixir"]);

export function isWordPotionHint(hint) {
  return Boolean(hint && WORD_POTION_HINT_TYPES.has(hint.type));
}

export function shouldAutoHidePotionHint(hint) {
  return Boolean(hint && !isWordPotionHint(hint));
}
